import { Repository } from "./adapters/repository";

import * as submitMessage from "./useCases/submitMessage";
import * as retrieveConversations from "./useCases/retrieveConversations";
import * as getConversationMessages from "./useCases/getConversationMessages";
import * as deleteConversation from "./useCases/deleteConversation";
import * as cancelJob from "./useCases/cancelJob";
import * as resetMemory from "./useCases/resetMemory";

enum UseCases {
  submitMessage = "submitMessage",
  retrieveConversations = "retrieveConversations",
  getConversationMessages = "getConversationMessages",
  deleteConversation = "deleteConversation",
  cancelJob = "cancelJob",
  resetMemory = "resetMemory",
}

interface Core {
  [UseCases.submitMessage]: submitMessage.Interactor;
  [UseCases.retrieveConversations]: retrieveConversations.Interactor;
  [UseCases.getConversationMessages]: getConversationMessages.Interactor;
  [UseCases.deleteConversation]: deleteConversation.Interactor;
  [UseCases.cancelJob]: cancelJob.Interactor;
  [UseCases.resetMemory]: resetMemory.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.submitMessage]: submitMessage.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveConversations]: retrieveConversations.createInteractor(
      dependencies.repository,
    ),
    [UseCases.getConversationMessages]:
      getConversationMessages.createInteractor(dependencies.repository),
    [UseCases.deleteConversation]: deleteConversation.createInteractor(
      dependencies.repository,
    ),
    [UseCases.cancelJob]: cancelJob.createInteractor(dependencies.repository),
    [UseCases.resetMemory]: resetMemory.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
